import React from 'react';

import subProgramClasses from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/SubProgramPreferences/components/subProgramPreferences.module.scss';
import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/SubProgramPreferences/progressMeasurement/progressMeasurement.module.scss';
import { ProgressMeasurementPreference } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/SubProgramPreferences/progressMeasurementPreference/progressMeasurementPreference';

export const ProgressMeasurement = () => {
    return (
        <div data-testid={'progress-measurement'} className={classes.progressMeasurement}>
            <span className={subProgramClasses.title}>Progress Measurement: </span>
            <div className={classes.container}>
                <ProgressMeasurementPreference />
            </div>
        </div>
    );
};
